"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ScoreCircle = exports.getNegativeColor = exports.getPositiveColor = void 0;
const react_1 = __importStar(require("react"));
const styled_components_1 = __importStar(require("styled-components"));
const base_react_components_1 = require("@navinc/base-react-components");
const CircleScore = styled_components_1.default.text.withConfig({ displayName: "reports-CircleScore", componentId: "reports-y2y8ft" }) `
  font-family: 'postgrotesk', 'Averta', 'Helvetica', sans-serif;
  font-weight: bold;
`;
const dash = (0, styled_components_1.keyframes) `
    to {
        stroke-dashoffset: 0;
    }
`;
/* MaxCircle is used when the score is at 100%, as the arc cannot accommodate 360deg */
const MaxCircle = styled_components_1.default.circle.withConfig({ displayName: "reports-MaxCircle", componentId: "reports-1ln8azo" }) `
  stroke-dasharray: ${({ lineLength }) => lineLength};
  stroke-dashoffset: ${({ lineLength }) => lineLength};
  animation: ${dash} 3s forwards;
  transform: rotate(-90deg);
  transform-origin: center;
`;
const CircleProgress = styled_components_1.default.path.withConfig({ displayName: "reports-CircleProgress", componentId: "reports-1byq3cg" }) `
  stroke-dasharray: ${({ lineLength }) => lineLength};
  stroke-dashoffset: ${({ lineLength }) => `-${lineLength}`};
  animation: ${dash} 3s forwards;
`;
const polarToCartesian = (centerX, centerY, radius, angleInDegrees) => {
    const angleInRadians = ((angleInDegrees - 90) * Math.PI) / 180.0;
    return {
        x: centerX + radius * Math.cos(angleInRadians),
        y: centerY + radius * Math.sin(angleInRadians),
    };
};
const getArcPath = (x, y, radius, startAngle, endAngle) => {
    const start = polarToCartesian(x, y, radius, endAngle);
    const end = polarToCartesian(x, y, radius, startAngle);
    const largeArcFlag = endAngle - startAngle <= 180 ? '0' : '1';
    const d = ['M', start.x, start.y, 'A', radius, radius, 0, largeArcFlag, 0, end.x, end.y].join(' ');
    return d;
};
const getPositiveColor = (score = 0, maxLowRange = 0, maxMidRange = 0) => {
    if (score > maxMidRange)
        return base_react_components_1.theme.good;
    if (score > maxLowRange)
        return base_react_components_1.theme.fair;
    return base_react_components_1.theme.poor;
};
exports.getPositiveColor = getPositiveColor;
const getNegativeColor = (score = 0, maxLowRange = 0, maxMidRange = 0) => {
    if (score > maxMidRange)
        return base_react_components_1.theme.poor;
    if (score > maxLowRange)
        return base_react_components_1.theme.fair;
    return base_react_components_1.theme.good;
};
exports.getNegativeColor = getNegativeColor;
/**
 * The Score Circle reflects animated a given score around the circle to the percentage of completion, as specified by
 * the maxScore score provided. The additional props are used to determine the color gradation of the given score.
 */
const ScoreCircle = ({ score = 0, minScore = 0, maxLowRange = 0, maxMidRange = 0, maxScore = 0, hasInvertedColor = false, color, }) => {
    const [lineLength, setLineLength] = (0, react_1.useState)(0);
    const circleDimension = 150;
    const vHeight = circleDimension;
    const vWidth = circleDimension;
    const circleRadius = circleDimension / 3;
    const centerPoint = circleDimension / 2;
    const circleStrokeWidth = circleDimension / 16;
    const hasMaxScore = score >= maxScore;
    const pathLength = (node) => {
        if (node !== null) {
            try {
                const length = node.getTotalLength();
                setLineLength(length);
            }
            catch (_a) {
                setLineLength(0);
            }
        }
    };
    const progressAngle = (360 * (score - minScore)) / (Math.max(score, maxScore) - minScore);
    const getColor = color !== null && color !== void 0 ? color : (hasInvertedColor
        ? (0, exports.getNegativeColor)(score, maxLowRange, maxMidRange)
        : (0, exports.getPositiveColor)(score, maxLowRange, maxMidRange));
    return (react_1.default.createElement("svg", { viewBox: `0 0 ${vWidth} ${vHeight}`, "data-testid": "scoreCircle" },
        react_1.default.createElement("circle", { cx: centerPoint, cy: centerPoint, r: circleRadius, strokeWidth: circleStrokeWidth, stroke: base_react_components_1.theme.neutral200, fill: "none" }),
        hasMaxScore ? (react_1.default.createElement(MaxCircle, { ref: pathLength, cx: centerPoint, cy: centerPoint, r: circleRadius, strokeWidth: circleStrokeWidth, stroke: getColor, fill: "none", lineLength: lineLength, strokeLinecap: "round" })) : (react_1.default.createElement(CircleProgress, { ref: pathLength, "data-testid": "circleProgress", d: getArcPath(centerPoint, centerPoint, circleRadius, 0, progressAngle), stroke: getColor, strokeWidth: circleStrokeWidth, fill: "none", strokeLinecap: "round", lineLength: lineLength })),
        react_1.default.createElement(CircleScore, { "data-testid": "circleScore", textAnchor: "middle", x: centerPoint, y: centerPoint + circleDimension / 20, fontSize: `${circleDimension / 5}px` },
            score,
            "%")));
};
exports.ScoreCircle = ScoreCircle;
exports.default = exports.ScoreCircle;
//# sourceMappingURL=index.js.map